import PropTypes from 'prop-types'
import { StyleSheet, css } from 'aphrodite'
import appleStore from '../../assets/apple-store.png'

function UIApplestoreButton({ dynamicStyle, ...props }) {
  return (
    <img
      src={appleStore}
      onClick={() => {
        window.open(
          'https://apps.apple.com/us/app/ubiqeyes/id1611736754',
          '_blank',
          'noopener,noreferrer'
        )
      }}
      className={css(styles.image, dynamicStyle && dynamicStyle)}
      alt="applestore button"
      width="100%"
      height="100%"
      {...props}
    />
  )
}

const styles = StyleSheet.create({
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
})

UIApplestoreButton.propTypes = {
  dynamicStyle: PropTypes.object,
}

export default UIApplestoreButton
